"use client";
import React from "react";
import Button from "./Button";

function InfoSection({
  imageArray,
  gap = "0.5rem",
  descriptionhead,
  title,
  icon,
  subtitle,
  description,
  additionalText,
  buttonText,
  textColor = "#6200EE",
  paraColor = "#1E1E1E",
  width = "max-w-full",
  descriptionClass = "",
  descriptionHidden = true,
  path='',
  disable=false,
  hoverICon,
  titleClass,
  smallContainer,
}) {
  return (
    <div className={`flex flex-col items-center space-y-2 lg:space-y-3`}>
      <span
        className={`font-poppins font-bold text-sm tracking-wide ${titleClass}`}
        style={{ color: `${textColor}` }}
      >
        {title}
      </span>
      <h2
        style={{ color: `${textColor}` }}
        className={`font-poppins text-center font-bold text-2xl leading-10 sm:text-[32px] sm:leading-[44px] tracking-tight ${width}`}
      >
        {subtitle}
      </h2>
      <div
        className={`${width} text-base sm:text-sm ${descriptionHidden && `max-sm:hidden`} ${
          paraColor === "white" ? "opacity-100" : "opacity-70"
        }`}
        style={{ color: `${paraColor}` }}
      >
        <p className={`font-poppins font-normal leading-7 text-center mx-auto ${descriptionClass}`}>
          {descriptionhead && (
            <span>
              At <span className="font-semibold mr-1">RegTechFlow,</span>
            </span>
          )}
          {description}
        </p>
        {additionalText && <p>{additionalText}</p>}
      </div>
      {Array.isArray(imageArray) && imageArray.length > 0 && (
        <div>
          <div className="flex flex-wrap sm:flex-row md:flex-row-reverse flex-col-reverse justify-center max-sm:items-center py-5 max-sm:gap-y-14 md:gap-x-14">
            {imageArray.map((item, index) => (
              <div key={index} className="relative w-[210px]">
                <img
                  src={item}
                  width={210}
                  height={88}
                  alt={item}
                  className="w-[210px] h-[88px] object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      )}
      {buttonText && (
        <Button ButtonText={buttonText} disable={disable} path={path} icon={icon} hoverIcon={hoverICon}/>
      )}
    </div>
  );
}

export default InfoSection;
